import React, { useState, useEffect, useRef, forwardRef } from "react";

const RevealText = forwardRef(
  (
    {
      isCandleOn,
      normalText = "sealuminati",
      hiddenText = "", // must be same length as normalText
      forceHover = false,
      className = "",
      style = {},
    },
    ref // forwardRef so parent can do textRef.current
  ) => {
    const [revealIndex, setRevealIndex] = useState(0);
    const intervalId = useRef(null);

    useEffect(() => {
      // Only reveal if flashlight is on (candle is off) AND "forceHover" is true
      if (!isCandleOn && forceHover) {
        // Start a timer that increments revealIndex every 200ms
        intervalId.current = setInterval(() => {
          setRevealIndex((prev) => {
            if (prev < normalText.length) {
              return prev + 1;
            } else {
              // once fully revealed, clear interval
              clearInterval(intervalId.current);
              return prev;
            }
          });
        }, 200);
      } else {
        // Candle turned on OR not hovered => reset
        setRevealIndex(0);
        if (intervalId.current) {
          clearInterval(intervalId.current);
        }
      }

      return () => {
        // Clean up timer on unmount or re‐render
        if (intervalId.current) {
          clearInterval(intervalId.current);
        }
      };
    }, [isCandleOn, forceHover, normalText.length]);

    // Build the displayed text:
    // letters before revealIndex come from hiddenText
    // letters after revealIndex come from normalText
    const displayed = normalText.split("").map((char, i) => {
      if (i < revealIndex) {
        return hiddenText[i];
      }
      return char;
    });

    return (
      <h1
        ref={ref}
        className={className}
        style={style}
      >
        {displayed.join("")}
      </h1>
    );
  }
);

export default RevealText;
